module.exports = __webpack_public_path__ + "static/media/icon-search-active.cf8190eb.svg";